import "./payment.css";
import ContextUs from "../../Templates/Common/ContactUs";
import { useState } from "react";
import { Outlet } from 'react-router-dom';

function Payment() {

    const [tab, setTab] = useState(1);

    return (
        <div>
            <div className="mt-10 mb-10 flex justify-center">
                {/* Progress Bar */}
                <div className="flex gap-5">
                    <PrgressItem count={1} isNextState={true} text="Find" state={tab} />
                    <PrgressItem count={2} isNextState={true} text="Plan" state={tab}/>
                    <PrgressItem count={3} isNextState={false} text="Pay" state={tab}/>
                </div>
            </div>
            <Outlet context={{setTab}} />
            <ContextUs />
        </div>
    )
}

function PrgressItem({text, state, isNextState, count}) {
    return (
        <div className={`progress-item font-bold text-white md:pl-14 md:pr-14 pl-8 pr-8 pt-2 pb-2 rounded-3xl ${count === state ? "active-page" : count > state ? "not-visited" : "visited"}`}>{text}
            {isNextState && <div className={count === state ? "active-page" : count > state ? "not-visited" : "visited"}></div>}
        </div>
    )
}

export default Payment;